import { render, staticRenderFns } from "./AutoGrowTextArea.vue?vue&type=template&id=ad3993e8&scoped=true"
import script from "./AutoGrowTextArea.vue?vue&type=script&lang=js"
export * from "./AutoGrowTextArea.vue?vue&type=script&lang=js"
import style0 from "./AutoGrowTextArea.vue?vue&type=style&index=0&id=ad3993e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3993e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad3993e8')) {
      api.createRecord('ad3993e8', component.options)
    } else {
      api.reload('ad3993e8', component.options)
    }
    module.hot.accept("./AutoGrowTextArea.vue?vue&type=template&id=ad3993e8&scoped=true", function () {
      api.rerender('ad3993e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AutoGrowTextArea.vue"
export default component.exports